import {type MouseEventHandler, useCallback} from 'react';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';

import './FallbackComponent.sass';

interface FallbackComponentProps {
  // biome-ignore lint/suspicious/noExplicitAny: error boundary sends any
  error: any;
}

export const FallbackComponent = ({error}: FallbackComponentProps) => {
  const refresh: MouseEventHandler<HTMLButtonElement> = useCallback((e) => {
    e?.preventDefault();
    window.location.reload();
  }, []);

  return (
    <div className="fallback-component__container">
      <div className="fallback-component__center-box">
        <Typography variant="header5">
          Uh oh! There was an error. Please{' '}
          <Button
            data-qa-id="refresh-page"
            variant="link"
            onClick={refresh}
            className="fallback-component__refresh-button"
          >
            <Typography variant="header5" color="link">
              refresh
            </Typography>
          </Button>{' '}
          the page, and contact support if it continues.
        </Typography>
      </div>
    </div>
  );
};
